import React from 'react';
import Avatar from '@atlaskit/avatar';
import { emptyStateSearchTabs, PPC_TABS, TableHeading } from '@css-xp/ppc-common';
import { DynamicResultTable } from '@css-xp/base';
import { EndCustomerContact } from '@css-xp/graphtypes/src/generated-types-new';
import './ecc-table.scss';

export interface EccTableProps {
  endCustomerContacts: EndCustomerContact[];
  isLoading: boolean;
}

const makeColumns = (customerContacts: EndCustomerContact[]) => {
  return customerContacts.map((user: EndCustomerContact) => {
    return {
      key: user.accountId,
      cells: [
        {
          content: (
            <div className="ecc-row">
              <div className="ecc-details-section">
                <Avatar src={user.picture || ''} size="large" />
                <div className="ecc-details-name-email">
                  <div className="ecc-details-name">{user.name}</div>
                  <div className="ecc-details-email">{user.email || ''}</div>
                </div>
              </div>
            </div>
          ),
        },
      ],
    };
  });
};

export const EccTable = (eccTableProps: EccTableProps) => {
  const { endCustomerContacts, isLoading } = eccTableProps;

  return (
    <div className="ecc-container">
      <DynamicResultTable
        testId={'ecc'}
        beforeTable={<TableHeading>{PPC_TABS.CUSTOMER_CONTACTS}</TableHeading>}
        head={{ cells: [] }}
        rows={makeColumns(endCustomerContacts)}
        emptyStateProps={emptyStateSearchTabs}
        isPaginationEnabled={false}
        isLoading={isLoading}
      />
    </div>
  );
};
